import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../../../Environment/environment';
@Component({
  selector: 'app-image-pop-up',
  templateUrl: './image-pop-up.component.html',
  styleUrl: './image-pop-up.component.css'
})
export class ImagePopUpComponent {
  AssetbasePath:any;
  constructor(public dialog: MatDialog,) {
    this.AssetbasePath = environment.assetsPath;
  }
  @Output() close = new EventEmitter<void>();


  closePopup(){
    this.dialog.closeAll()
    }
}
